import React from "react";

interface HookRunnerProps {
  hookFn: (...args: any[]) => any;
  hookName: string;
}

export function HookRunner({ hookFn, hookName }: HookRunnerProps) {
  // Call the hook and display its output
  let result: any;
  let error: any = null;
  try {
    result = hookFn();
  } catch (e) {
    error = e;
  }
  return (
    <div>
      <div className="font-mono text-xs mb-2">{hookName}()</div>
      {error ? (
        <pre className="bg-destructive/10 p-2 rounded text-xs text-destructive overflow-x-auto">
          {String(error)}
        </pre>
      ) : (
        <pre className="bg-muted p-2 rounded text-xs overflow-x-auto">
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  );
}
